import _extends from "@babel/runtime/helpers/esm/extends";
import { GridPushPinRightIcon, GridPushPinLeftIcon } from "./icons.js";
const iconSlots = {
  columnMenuPinRightIcon: GridPushPinRightIcon,
  columnMenuPinLeftIcon: GridPushPinLeftIcon
};
const materialSlots = _extends({}, iconSlots);
export default materialSlots;